/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Goodie } from '../models/Goodie';
import type { GoodieRequest } from '../models/GoodieRequest';
import type { PaginatedGoodieList } from '../models/PaginatedGoodieList';
import type { PatchedGoodieRequest } from '../models/PatchedGoodieRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class GoodiesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Permission Viewset mixin to override the default
     * behavior from AutoPermissionViewSetMixin.
     * @returns PaginatedGoodieList
     * @throws ApiError
     */
    public goodiesList({
        limit,
        offset,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedGoodieList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/goodies/',
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * Permission Viewset mixin to override the default
     * behavior from AutoPermissionViewSetMixin.
     * @returns Goodie
     * @throws ApiError
     */
    public goodiesCreate({
        requestBody,
    }: {
        requestBody: GoodieRequest,
    }): CancelablePromise<Goodie> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/goodies/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Permission Viewset mixin to override the default
     * behavior from AutoPermissionViewSetMixin.
     * @returns Goodie
     * @throws ApiError
     */
    public goodiesRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this goodie.
         */
        id: string,
    }): CancelablePromise<Goodie> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/goodies/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Permission Viewset mixin to override the default
     * behavior from AutoPermissionViewSetMixin.
     * @returns Goodie
     * @throws ApiError
     */
    public goodiesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this goodie.
         */
        id: string,
        requestBody: GoodieRequest,
    }): CancelablePromise<Goodie> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/goodies/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Permission Viewset mixin to override the default
     * behavior from AutoPermissionViewSetMixin.
     * @returns Goodie
     * @throws ApiError
     */
    public goodiesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this goodie.
         */
        id: string,
        requestBody?: PatchedGoodieRequest,
    }): CancelablePromise<Goodie> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/goodies/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Permission Viewset mixin to override the default
     * behavior from AutoPermissionViewSetMixin.
     * @returns void
     * @throws ApiError
     */
    public goodiesDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this goodie.
         */
        id: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/goodies/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
